import {billingEventPolling} from "@/apis";
import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

export const EventStatusCode = {
  PENDING: 1,
  FAILURE: 2,
  SUCCESS: 3,
};

export const EventType = {
  // desc: buy it now
  // error message i18n: error.billing.subscribe.create_failed
  BuyItNowEvent: 1,
  // desc: free without cc subscribe
  // error message i18n: error.billing.free_upgrade_failed
  FreeWithoutCCSubscribeEvent: 2,
  // desc: free with cc subscribe
  // error message i18n: error.billing.free_with_cc.subscribe_failed
  FreeWithCCSubscribeEvent: 3,
  // desc: zoom room upgrade
  // error message i18n: error.billing.upgrade_failed
  ZoomRoomUpgradeEvent: 4,
  // desc: pro upgrade
  // error message i18n: error.billing.upgrade_failed
  ProUpgradeEvent: 5,
  // desc: update base plan
  // error message i18n: error.billing.update_failed
  BasePlanUpdateEvent: 6,
  // desc: add addon plan
  // error message i18n: error.billing.update_failed
  AddonPlanAddEvent: 7,
  // desc: update addon plan
  // error message i18n: error.billing.update_failed
  AddonPlanUpdateEvent: 8,
  // desc: batch cancel
  // error message i18n: error.billing.change_failed
  BatchCancelEvent: 9,
  // desc: batch cancel addon plan
  // error message i18n: error.billing.change_failed
  BatchCancelAddonPlanEvent: 10,

  // desc: free upgrade for sub account
  // error message i18n: error.billing.free_upgrade_failed
  SubFreeUpgradeEvent: 11,
  // desc: zoom room upgrade for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubZoomRoomUpgradeEvent: 12,
  // desc: pro upgrade for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubProUpgradeEvent: 13,
  // desc: biz downgrade for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubBizDowngradeEvent: 14,
  // desc: update base plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubBasePlanUpdateEvent: 15,
  // desc: update addon plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubAddonPlanUpdateEvent: 16,
  // desc: add addon plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubAddonPlanAddEvent: 17,
  // desc: cancel base plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubBasePlanCancelEvent: 18,
  // desc: cancel addon plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubAddonPlanCancelEvent: 19,

  // desc: update billto
  // error message i18n: error.billing.billto.update_failed
  UpdateBillToEvent: 20,
  // desc: update soldto
  // error message i18n: error.billing.soldto.update_failed
  UpdateSoldToEvent: 21,
  // desc: pay open invoice(invoice history)
  // error message i18n: error.billing.pay_invoice.failed
  PayOpenInvoiceEvent: 22,
  // desc: pay open invoice one time
  // error message i18n: error.billing.pay_invoice.failed
  PayOpenInvoiceOneTimeEvent: 23,
  // desc: cancel addon plan
  // error message i18n: error.billing.change_failed
  CancelAddonPlanEvent: 24,

  // desc: cancel base plan
  // error message i18n: error.billing.change_failed
  CancelBasePlanEvent: 25,

  // desc: reactivate base plan
  // error message i18n: error.billing.change_failed
  BasePLanReactivateEvent: 26,
  // desc: reactivate addon plan
  // error message i18n: error.billing.change_failed
  AddonPlanReactivateEvent: 27,
  // desc: reactivate base plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubBasePlanReactivateEvent: 28,
  // desc: reactivate addon plan for sub account
  // error message i18n: error.billing.sub_account.update_failed
  SubAddonPlanReactivateEvent: 29,

  // desc: upgrade to united
  // error message i18n: error.billing.upgrade_failed
  UpgradeToUnitedEvent: 30,
  // desc: update/edit UC bundle plan
  // error message i18n: error.billing.update_failed
  UCBundlePlanUpdateEvent: 31,
  // desc: batch upgrade united
  // error message i18n: error.billing.upgrade_failed
  BatchUpgradeToUnitedEvent: 32,

  // desc: upgrade to united
  // error message i18n: error.billing.upgrade_failed
  SubUpgrade2UnitedEvent: 33,
  // desc: batch upgrade to united
  // error message i18n: error.billing.upgrade_failed
  SubBatchUpgrade2UnitedEvent: 34,
  // desc: united downgrade
  // error message i18n: error.billing.sub_account.update_failed
  SubUnitedDowngradeEvent: 35,
  // desc: batch united downgrade
  // error message i18n: error.billing.sub_account.update_failed
  SubBatchUnitedDowngradeEvent: 36,

  // zoom united swap
  // desc: zoom united swap
  // error message i18n: error.billing.upgrade_failed
  ZoomUnitedSwapEvent: 37,

  //INR Pre Sync Event
  // desc: buy it now pre INR
  // error message i18n: error.billing.subscribe.create_failed
  BuyItNowInrPreEvent: 38,

  //INR Post aSync Event
  // desc: buy it now post INR
  // error message i18n: error.billing.subscribe.create_failed
  BuyItNowInrPostEvent: 39,

  // coupon sync zuora event
  // desc: coupon by active
  CouponAddEvent: 45,
}

export const pollingEventStatus = async (options = {}) => {
  return new Promise((resolve, reject) => {
    const {pollingIntervalTime = 5000, maxRetryTimes = 60, previewKey = '', eventType} = options;

    pollingEventStatus.__preview_key__ = previewKey;

    let setTimeoutEvent = null;
    let retryTimes = 0;

    const pollingInterval = async function () {
      try {
        clearTimeOutEvent();
        if (previewKey && pollingEventStatus.__preview_key__ && pollingEventStatus.__preview_key__ !== previewKey) {
          return console.log(`polling stops at previewKey: ${previewKey}, and goes to: ${pollingEventStatus.__preview_key__}`); // polling stops here, cuz there comes another new polling
        }
        retryTimes++;
        const {result} = await billingEventPolling(previewKey);

        if (Number(result?.status) === EventStatusCode.SUCCESS && (!eventType || parseInt(result?.eventType) === eventType)) {
          resolve(result);
        } else if (Number(result?.status) === EventStatusCode.FAILURE) {
          emit(EVENT_TYPES.POLLING_ERROR, result);
          handleReject(result)
        } else {
          handlerEvent();
        }
      } catch (e) {
        reject(typeof e === "string" ? e : e?.message);
      }
    };

    function clearTimeOutEvent() {
      setTimeoutEvent && clearTimeout(setTimeoutEvent);
    }

    function handlerEvent() {
      if (retryTimes > maxRetryTimes) {
        reject('retry limit');
      } else {
        setTimeoutEvent = setTimeout(pollingInterval, pollingIntervalTime);
      }
    }

    function handleReject(result) {
      if(options.rps && result?.rpsStatus){
        reject(result);
      }else{
        reject(result?.errorMsg || 'unknown error');
      }
    }

    pollingInterval();
  })
}
